import styled from 'styled-components';
const ButtonGroupStyled = styled.div`
  /* height: 88px; */
  background-color: #fff;
  align-items: center;
  padding-top: 56px;
  /* margin-bottom: 24px; */
  .search {
    margin-right: 16px;
  }
`;
export default ButtonGroupStyled;
